export enum AssigneeType {
	USER = 'USER',
	GROUP = 'GROUP',
	HIERARCHY = 'HIERARCHY'
}